// Re-exported for use by HotelPDP3 without directly coupling to HotelPDPPageV2
export type { TravelOffer, TravelOfferUnitComponent } from './EventAccommodations/routes/HotelPDPPageV2/HotelPDPPageV2.types';

export type Property = {
  address: string | null;
  id: string;
  images: Array<{ src: string; alt: string }>;
  displayName: string | null;
  rating: number | null;
  description: string | null;
  location: { lat: number; lon: number } | null;
  highlightedAmenities: Array<{ display: string; id: string }>;
  amenities: Array<{ display: string; id: string }>;
};

export type Unit = {
  id: string;
  images: Array<{ src: string; alt: string }>;
  displayName: string;
  rating: number | null;
  size: string | null;
  sleepsNumber: number;
  beds: string;
  displayRate: string;
  amenities: Array<{ display: string; id: string }>;
};

export type StaysSearchTerms = {
  destination: string;
  lat: number;
  lng: number;
  googlePlaceId?: string;
  startDate: {
    year: number;
    month: number;
    day: number;
  };
  endDate: {
    year: number;
    month: number;
    day: number;
  };
  rooms: Array<{
    adults: number;
    childrenAges: Array<number>;
  }>;
  loading?: boolean;
};

/**
 * Property identifier types for accommodations
 * Extends the GraphQL AccommodationCatalogPropertyIdentifierV2Type to include accommodationPlace
 */
export enum PropertyIdentifierType {
  JoyPlace = 'joyPlace',
  AccommodationPlace = 'accommodationPlace',
}

/**
 * Consolidated property identifier type
 */
export type PropertyIdentifier = {
  readonly id: string;
  readonly type: PropertyIdentifierType;
};

/**
 * Pricing API call source identifier
 * Used to track which part of the application is making pricing requests
 */
export enum PricingApiCallSource {
  GuestMap = 'guest_map',
  AdminMap = 'admin_map',
  GuestAccommodation = 'guest_accommodation',
  AdminAccommodation = 'admin_accommodation',
}
